'use strict';

var transformDateTimePartNumberToStringWithZeroPadding = require('../common/transformDateTimePartNumberToStringWithZeroPadding.cjs');

const assemblePartsToISODatePartWithoutYear = (dateParts) => {
  return [
    "-",
    ...[dateParts.month, dateParts.day].map(
      (part) => transformDateTimePartNumberToStringWithZeroPadding(part)
    )
  ].join("-");
};

module.exports = assemblePartsToISODatePartWithoutYear;
//# sourceMappingURL=assemblePartsToISODatePartWithoutYear.cjs.map
